import React, { Component, PropTypes } from 'react';
import Modal from 'components/Modal';
import TabPanelControl from 'components/TabPanelControl';
import { translate as t } from 'lang';
import RestorePasswordEmailDialogContent from 'components/RestorePasswordEmailDialogContent';
import RestorePasswordPhoneDialogContent from 'components/RestorePasswordPhoneDialogContent';
import RestorePasswordCodeDialogContent from 'components/RestorePasswordCodeDialogContent';
import RestorePasswordNewPasswordDialogContent from 'components/RestorePasswordNewPasswordDialogContent';

import './RestorePasswordDialog.scss';

class RestorePasswordDialog extends Component {

    static propTypes = {
        onCloseDialog: PropTypes.func,
        onSubmit: PropTypes.func,
        onRestorePasswordComplete: PropTypes.func,
    }

    state = {
        email: '',
        phone: '',
        code: '',
        method: 'email',
        activeEmailBlock: 'RestorePasswordEmailDialogContent',
        activePhoneBlock: 'RestorePasswordPhoneDialogContent',
        emailNewPassword: '',
        emailNewPasswordRepeat: '',
        phoneNewPassword: '',
        phoneNewPasswordRepeat: '',
    }

    _onSelectMethod = (newIndex) => {

        var method = '';

        switch (newIndex) {
            case 0:
                method = 'email';
                break;
            case 1:
                method = 'sms';
                break;
            default:
                method = 'email';
                break;
        }

        this.setState({
            method: method
        });
    }
    
    _onChangeInputValueToEmail = (oldEmail) => {
        this.setState({
            email: oldEmail,
            activeEmailBlock: 'RestorePasswordEmailDialogContent',
        });
    }

    _onChangeInputValueToPhone = (oldPhone) => {
        this.setState({
            phone: oldPhone,
            activePhoneBlock: 'RestorePasswordPhoneDialogContent',
        });
    }

    _onRestorePasswordEmailDialogContentSubmit = (email) => {
        this.setState({
            email: email,
            activeEmailBlock: 'RestorePasswordCodeDialogContent',
        });
    }

    _onRestorePasswordPhoneDialogContentSubmit = (phone) => {
        this.setState({
            phone: phone,
            activePhoneBlock: 'RestorePasswordCodeDialogContent',
        });
    }

    _onRestorePasswordCodeDialogContentSubmit = (code) => {
        switch (this.state.method) {
            case 'email':
                this.setState({
                    code: code,
                    activeEmailBlock: 'RestorePasswordNewPasswordDialogContent',
                });
                break;
            case 'sms':
                this.setState({
                    code: code,
                    activePhoneBlock: 'RestorePasswordNewPasswordDialogContent',
                });
                break;
        }
    }

    _onRestorePasswordNewPasswordDialogContentSubmit = (autologinHash) => {
        if (this.props.onRestorePasswordComplete) {
            this.props.onRestorePasswordComplete(autologinHash);
        }
    }

    _getActiveEmailBlock = () => {

        var activeBlock = '';

        switch (this.state.activeEmailBlock) {
            case 'RestorePasswordEmailDialogContent':
                activeBlock = (
                    <RestorePasswordEmailDialogContent
                        method={this.state.method}
                        inputValue={this.state.email}
                        onSubmit={this._onRestorePasswordEmailDialogContentSubmit} />
                );
                break;
            case 'RestorePasswordCodeDialogContent':
                activeBlock = (
                    <RestorePasswordCodeDialogContent
                        method={this.state.method}
                        inputValue={this.state.email}
                        onChangeInputValue={this._onChangeInputValueToEmail}
                        onSubmit={this._onRestorePasswordCodeDialogContentSubmit} />
                );
                break;
            case 'RestorePasswordNewPasswordDialogContent':
                activeBlock = (
                    <RestorePasswordNewPasswordDialogContent
                        method={this.state.method}
                        code={this.state.code}
                        inputValue={this.state.email}
                        onSubmit={this._onRestorePasswordNewPasswordDialogContentSubmit} />
                );
                break;
        }

        return activeBlock;
    }

    _getActivePhoneBlock = () => {

        var activeBlock = '';

        switch(this.state.activePhoneBlock) {
            case 'RestorePasswordPhoneDialogContent':
                activeBlock = (
                    <RestorePasswordPhoneDialogContent
                        method={this.state.method}
                        inputValue={this.state.phone}
                        onSubmit={this._onRestorePasswordPhoneDialogContentSubmit}/>
                );
                break;
            case 'RestorePasswordCodeDialogContent':
                activeBlock = (
                    <RestorePasswordCodeDialogContent
                        method={this.state.method}
                        inputValue={this.state.phone}
                        onChangeInputValue={this._onChangeInputValueToPhone}
                        onSubmit={this._onRestorePasswordCodeDialogContentSubmit} />
                );
                break;
            case 'RestorePasswordNewPasswordDialogContent':
                activeBlock = (
                    <RestorePasswordNewPasswordDialogContent
                        method={this.state.method}
                        code={this.state.code}
                        inputValue={this.state.phone}
                        onSubmit={this._onRestorePasswordNewPasswordDialogContentSubmit} />
                );
                break;
        }

        return activeBlock;
    }

    _onModalClose = () => {
        if (this.props.onCloseDialog) {
            this.props.onCloseDialog();
        }
    }

    render() {

        var activeEmailBlock = this._getActiveEmailBlock();
        var activePhoneBlock = this._getActivePhoneBlock();

        var content = (
            <TabPanelControl onActivate={this._onSelectMethod}
                      defaultActiveIndex={0}>
                <div className="RestorePasswordDialog-tab RestorePasswordDialog-emailMethod" tabTitle="По эл. почте">
                    {activeEmailBlock}
                    <div className="RestorePasswordDialog-helpBox">
                        {t('NEED_SUPPORT_HELP')}
                    </div>
                </div>
                <div className="RestorePasswordDialog-tab RestorePasswordDialog-phoneMethod" tabTitle="Код на моб. телефон">
                    {activePhoneBlock}
                    <div className="RestorePasswordDialog-helpBox">
                        {t('NEED_SUPPORT_HELP')}
                    </div>
                </div>
            </TabPanelControl>
        );

        return (
            <div className="RestorePasswordDialog">
                <Modal title={t('RESTORE_PASSWORD')}
                       saveText={t('CONTINUE')}
                       content={content}
                       onClose={this._onModalClose}
                       isSaveButton={false}
                       isCloseButton={false} />
            </div>
        );
    }
}

export default RestorePasswordDialog;



// WEBPACK FOOTER //
// ./client/components/RestorePasswordDialog/RestorePasswordDialog.js